import { render, staticRenderFns } from "./BancontactHeader.vue?vue&type=template&id=82822bec&scoped=true&"
import script from "./BancontactHeader.vue?vue&type=script&lang=js&"
export * from "./BancontactHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82822bec",
  null
  
)

export default component.exports